<template>
  <div class="horse-list">
		<table>
			<thead>
				<tr>
					<th>
						<div class="bar bg-blue">
							<h3>Jobs</h3>
						</div>
					</th>
					<!-- <th>
						<div class="bar bg-brown">
							<p>COLOUR</p>
						</div>
					</th> -->
				</tr>
			</thead>
			<tbody>
				<tr v-for="(job, i) in jobs" :key="i">
					<td class="name">{{ job.name }}</td>
					<!-- <td class="colour">{{ job.colour }}</td> -->
					<td class="icon edit">
						<button class="button-transparent" @click="$emit('edit', job)">
							<i class="ss-write ss-glyphish-filled"></i>
						</button>
					</td>
					<td class="icon delete">
						<button class="button-transparent" @click="$emit('delete', job)">
							<i class="ss-trash ss-glyphish-filled"></i>
						</button>
					</td>
				</tr>
				<tr v-if="jobs.length === 0">
					<td colspan="6">No jobs found</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
export default {
	props: ['jobs'],
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Jobs/List.vue